export const useAppVersionCheck = (): void => {};
